var _style, _rect, _g, _rect2, _g2, _rect3, _circle, _rect4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2Square(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st25{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st24{fill:#FFFFFF;}\n\t.st23{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0544,3.0544;}\n\t.st21{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0187,3.0187;}\n\t.st20{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0494,3.0494;}\n\t.st19{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9498,2.9498;}\n\t.st18{fill:#010101;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 197.85,
    y: 178.7,
    className: "st25",
    width: 155.96,
    height: 166.36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "349.11,340.36 202.55,340.36 202.55,183.4 349.11,183.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 349.11,
    y1: 340.36,
    x2: 347.61,
    y2: 340.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 344.55,
    y1: 340.36,
    x2: 205.58,
    y2: 340.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "204.05,340.36 202.55,340.36 202.55,338.86  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 202.55,
    y1: 335.84,
    x2: 202.55,
    y2: 186.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "202.55,184.9 202.55,183.4 204.05,183.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 207.11,
    y1: 183.4,
    x2: 346.08,
    y2: 183.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 347.61,
    y1: 183.4,
    x2: 349.11,
    y2: 183.4
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.48,
    y: 177.51,
    className: "st25",
    width: 149.63,
    height: 168.74
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st24",
    points: "75.18,182.21 215.41,182.21 215.41,341.55 75.18,341.55  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 75.18,
    y1: 182.21,
    x2: 76.68,
    y2: 182.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 79.73,
    y1: 182.21,
    x2: 212.38,
    y2: 182.21
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "213.91,182.21 215.41,182.21 215.41,183.71  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 215.41,
    y1: 186.66,
    x2: 215.41,
    y2: 338.57
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st23",
    points: "215.41,340.05 215.41,341.55 213.91,341.55  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 210.86,
    y1: 341.55,
    x2: 78.21,
    y2: 341.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st23",
    x1: 76.68,
    y1: 341.55,
    x2: 75.18,
    y2: 341.55
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 169.22,
    y: 297.89,
    className: "st18",
    width: 39.5,
    height: 3.76
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 185.2,
    cy: 299.77,
    r: 15.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.76,
    y: 216.56,
    className: "st18",
    width: 39.5,
    height: 3.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 184.74,
    cy: 218.44,
    r: 15.52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Square);
export default __webpack_public_path__ + "static/media/2SQUARE.5edf88becae79165b758ce116b5983a4.svg";
export { ForwardRef as ReactComponent };